// extracted by mini-css-extract-plugin
export var displayNone = "_s4-6";
export var imgContainer = "_s4-2";
export var overflowHidden = "_s4-3";
export var productInfoCardButtonContainer = "_s4-5";
export var productTitleText = "_s4-4";
export var rightArrow = "_s4-1";
export var rightArrowContainer = "_s4-0";